export const testimonials = [
  {
    name: 'Sarah M.',
    location: 'Texas',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e480d697-eb4b-419f-985d-fee6378c1305.jpg',
    headline: 'I finally had something to follow.',
    quote: 'Before Calm Response 5™, every meltdown felt like a completely new emergency. Having a simple process to follow made me feel much more prepared.',
  },
  {
    name: 'Jessica R.',
    location: 'Florida',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8776a65c-f12e-4ab7-9840-c5c7396adb6b.jpg',
    headline: "I didn't have to remember everything.",
    quote: 'The SOS cards were my favorite part. I could quickly look at the situation instead of trying to remember everything I had read online.',
  },
  {
    name: 'Emily R.',
    location: 'California',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/64fe44e8-1a8a-4ee1-aa71-b22e6f59d61b.jpg',
    headline: 'I started noticing patterns.',
    quote: 'The Trigger & Pattern Map helped me pay attention to what was happening before the difficult moments instead of only focusing on the meltdown itself.',
  },
  {
    name: 'Rachel T.',
    location: 'Ohio',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/86588154-aedb-4e53-94f6-e72a56b54104.jpg',
    headline: 'The visual routines were so easy to use.',
    quote: 'The routine templates gave us something simple that everyone in the house could follow.',
  },
  {
    name: 'Amanda K.',
    location: 'New York',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f1e141ca-4a5e-4683-b996-58d22359b2a7.jpg',
    headline: 'It felt like a system, not another ebook.',
    quote: "I didn't feel like I was buying more information. I felt like I finally had a practical system.",
  },
];
